import { Guest } from '@/app/system/guest/Guest';
import { GuestAware } from '@/app/system/guest/GuestAware';
import { useRoute } from 'vue-router';

export class RouteIds implements GuestAware<number[]> {
  public receiving(guest: Guest<number[]>) {
    const route = useRoute();
    guest.receive(Array.from(new Set(String(route.params.id).split('-')
      .map(Number))));
    return this;
  }
}
